import type { Game } from "@/mocks/games";
import GameCard from "@/components/feature/GameCard";
import SectionHeader from "@/components/feature/SectionHeader";
import EmptyState from "@/components/base/EmptyState";

export default function HomePopular({ games }: { games: Game[] }) {
  return (
    <section aria-label="热门游戏推荐">
      <SectionHeader
        eyebrow="大家都在玩"
        title="热门游戏推荐"
        subtitle="根据近期试玩热度精选，免下载直接开玩，点击封面即可查看详情。"
        moreTo="/search"
        moreLabel="浏览全部游戏"
      />
      {games.length > 0 ? (
        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4">
          {games.map((game) => (
            <GameCard key={game.id} game={game} />
          ))}
        </div>
      ) : (
        <EmptyState icon="ri-gamepad-line" title="暂无推荐游戏" description="稍后再来看看，我们正在准备更多好玩的网页游戏。" />
      )}
    </section>
  );
}